import React, { useState, useEffect, useContext } from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';

import { auth } from '../../components/lib/firebase_auth';

import { Link } from "react-router-dom";
import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useCookies } from 'react-cookie';
import VpnKey from '@mui/icons-material/VpnKey';
import FacebookIcon from '@mui/icons-material/Facebook';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Grid from '@mui/material/Grid';
import Cookies from 'js-cookie';

import MenuItem from '@mui/material/MenuItem';
import Logout from '@mui/icons-material/Logout';

import authContext from "../home/authContext";

import MyLogo from '../../ressource/Logo-Opti-jeunesse.png';



import { getSessionValide, getUserRule, setSession, getCookieEmail, getIsAdmin } from '../../utils/userRule';

import { useSelector, useDispatch } from 'react-redux'



export default function OIMenu({ setTheme, userLog }) {

  const { userEmail, setUserEmail } = useContext(authContext);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorE2, setAnchorE2] = React.useState(null);
  const [anchorE3, setAnchorE3] = React.useState(null);
  const [anchorE4, setAnchorE4] = React.useState(null);


  const [menuReports, setMenuReports] = React.useState();
  const [menuSpetiaux, setMenuSpetiaux] = React.useState();
  const [menuFacturetDroitsSpetiaux, setMenuFacturetDroitsSpetiaux] = React.useState();

  //const [autorize, setAutorize] = useState(false);

  //const [cookies, setCookie, removeCookie] = useCookies(['token']);
  //
  const ButtonReport = "";

  useEffect(() => {

    /* let cookieValue = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*\=\s*([^;]*).*$)|^.*$/, "$1");
     // console.log(cookieValue);
      if(cookieValue)
      {           
          const user = jwt(cookieValue); // decode your token here
          // console.log("-----------------------:" +  user["user"]["expire"] > Math.round((new Date()).getTime() / 1000));
        //  console.log(user["user"]["expire"] + "   "  +  Math.round((new Date()).getTime() / 1000) );
          if(user["user"]["expire"] > Math.round((new Date()).getTime() / 1000)){   
              setAutorize(true); 
          }          
      }  */


    const fetchData = async () => {
      try {

        let TT = await getCookieEmail();
        console.log("TT=", TT);
        setUserEmail(TT);


        // Vos opérations asynchrones, par exemple une requête HTTP
        let RuleRead_Reports = await getUserRule("read_reports", sessionStorage.getItem('clubId'), sessionStorage.getItem('secteur'));
        let isuseradmin = await getIsAdmin();

        if (RuleRead_Reports === true) {
          setMenuReports(<Button aria-controls="simple-rapports"  variant="containedForth"
            aria-haspopup="true"
            onClick={handleClick3}
              sx={{ fontSize: '1.2rem' }}
          >          
              Rapports          
          </Button>);


          //********************************************** 
        }

        if (isuseradmin === true) {         
          setMenuSpetiaux(<Button aria-controls="simple-rapports"  variant="containedForth"
            aria-haspopup="true"
            onClick={handleClick4}
              sx={{ fontSize: '1.2rem' }}
          >
          
              Facture et droits spéciaux
        
          </Button>);

          setMenuFacturetDroitsSpetiaux(<Menu
            id="simple-sensible"

            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            anchorEl={anchorE4}
            open={Boolean(anchorE4)}
            onClose={handleClose}
          >
            <MenuItem onClick={handleClose} component={Link} to="/nouveauclub">Nouveau club (Pour Béatrice)</MenuItem>
            <MenuItem onClick={handleClose} component={Link} to="/genererFactureTrimestre">Facture en attente de paiement (Pour Béatrice)</MenuItem>
            <MenuItem onClick={handleClose} component={Link} to="/reports_effectif_one_date_sensitive">Rapport d’effectif détaillé pour une date (Pour Béatrice)</MenuItem>
            <MenuItem onClick={handleClose} component={Link} to="/reportsFacturation">Rapport de toutes les factures (Pour Béatrice)</MenuItem>
            <MenuItem onClick={handleClose} component={Link} to="/reports_membre_secteur">Liste des membres par secteur</MenuItem>
            <MenuItem onClick={handleClose} component={Link} to="/coupons">Gestion des rabais</MenuItem>
            <MenuItem onClick={handleClose} component={Link} to="/utilisateurs">Gestion des utilisateurs</MenuItem>

          </Menu>);




        }

      } catch (error) {
        console.error('Une erreur s\'est produite lors de la récupération des données', error);
      }
    };

    fetchData(); // Appel de la fonction asynchrone






    //   setAutorize(getSessionValide());

    // setUserEmail(Tmp);

    /*
          if(token !== undefined || userLog != "")      
            setUserEmail(Cookies.get('useremail'));    
          else
            setUserEmail("Vous n'êtes pas connecté.     ");
    
    
            console.log(userEmail);*/
    //console.log(localStorage.getItem("token"));
    // console.log("------------------------------");
    //alert("--" + userEmail + "--");
  }, [""]);


  function disconnect() {
    Cookies.set('token', "", { secure: true, sameSite: 'none' });
    Cookies.set('useremail', "");
    auth.signOut();
    //window.location.reload();
    window.location.href = process.env.REACT_APP_FRONTEND_UI + "/param";

  };

  function handleClick1(event) {
    console.log("handleClick1");
    setAnchorEl(event.currentTarget);
    console.log(anchorEl);
  };

  function handleClick2(event) {
    console.log("handleClick2");
    setAnchorE2(event.currentTarget);
    console.log(anchorE2);
  };


  function handleClick3(event) {
    console.log("handleClick3");
    setAnchorE3(event.currentTarget);
    console.log(anchorE3);
  };


  function handleClick4(event) {
    console.log("handleClick4");
    setAnchorE4(event.currentTarget);
    console.log(anchorE4);
  };


  const handleClose = () => {
    setAnchorEl(null);
    setAnchorE2(null);
    setAnchorE3(null);
    setAnchorE4(null);
  };


 // const URI_Google = process.env.REACT_APP_API + "/auth/google";
 // const URI_Facebook = process.env.REACT_APP_API + "/auth/facebook";
  const URI_Logout = process.env.REACT_APP_API + "/auth/logout";
  const URI_Login = process.env.REACT_APP_FRONTEND_UI + "/login";

  const ChangeTheme = (event) => {

    if (event.target.checked === true)
      setTheme("dark");
    else
      setTheme("light");

  };



/*
  const MaterialUISwitch = styled(Switch)(({ theme }) => ({
    width: 62,
    height: 34,
    padding: 7,
    '& .MuiSwitch-switchBase': {
      margin: 1,
      padding: 0,
      transform: 'translateX(6px)',
      '&.Mui-checked': {
        color: '#fff',
        transform: 'translateX(22px)',
        '& .MuiSwitch-thumb:before': {
          backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
            '#fff',
          )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
        },
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      backgroundColor: theme.palette.mode === 'dark' ? '#003892' : '#001e3c',
      width: 32,
      height: 32,
      '&:before': {
        content: "''",
        position: 'absolute',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
          '#fff',
        )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
      },
    },
    '& .MuiSwitch-track': {
      opacity: 1,
      backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
      borderRadius: 20 / 2,
    },
  }));

*/





  function AffDeconnection() {

    if (userEmail !== "" && userEmail !== undefined)
      return (<Button variant="containedSecondary" startIcon={<Logout />} onClick={disconnect} >Déconnexion </Button>);
    else
      return "";

  }

  return (


   <AppBar
      position="static" 
      elevation={0} // ← enlève l’ombre
      sx={{      
        backgroundColor: '#FAF3E4', color: '#20264C',
        margin: '10px', // 5px de marge à gauche et à droite
        borderTopLeftRadius: '12px', // coin supérieur gauche arrondi
        borderBottomLeftRadius: '12px', // coin supérieur gauche arrondi
        borderTopRightRadius: '12px', // coin supérieur droit arrondi
        overflow: 'hidden', // évite débordement de contenu dans les coins arrondis
        marginBottom: '30px' // si tu veux garder ça
      }}
    >


      <Toolbar sx={12} >
       

      </Toolbar>

     


    </AppBar>

  );
}
